import { Link } from 'react-router';
import { Card, EmptyState, linkButtonClass } from '../components';

export function NotFoundPage({ home = '/' }: { home?: string }) {
  return (
    <Card>
      <EmptyState
        title="There is nothing at this address"
        body="The link may be stale, or the section may not exist yet. Nothing has gone wrong with your agent."
        actions={
          <Link to={home} className={linkButtonClass('primary')}>
            Back to the console
          </Link>
        }
      />
    </Card>
  );
}

export default NotFoundPage;
